import Swiper, {Pagination} from "swiper/core";
Swiper.use([Pagination]);

export function InitSliders() {
	const swiperSliders = document.querySelectorAll('.swiper-container');
	if (swiperSliders.length === 0) return;

	swiperSliders.forEach((slider) => {
		let options = {
			slidersPerView: 1,
			spaceBetween: 20,
		};

		slider.classList.forEach((currentClass) => {
			let addedOptions;

			switch (currentClass) {
				case 'paginated':
					addedOptions = {
						pagination: {
							el: '.swiper-pagination',
							clickable: true,
							dynamicBullets: true,
							dynamicMainBullets: 3
						}
					};
					break;
				case 'three-dotted':
					addedOptions = {
						breakpoints: {
							768: {
								slidesPerView: 2,
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 30,
							}
						}		
					};
					break;
				case 'four-max':
					addedOptions = {
						breakpoints: {
							768: {
								slidesPerView: 3,
							},
							1024: {
								slidesPerView: 4,
								spaceBetween: 30,
							}
						}		
					}
				case 'contained-cards':
					addedOptions = {
						breakpoints: {
							slidesPerView: 2,
							spaceBetween: 10,
							768: {
								slidesPerView: 3,
								spaceBetween: 30,
							},
							1024: {
								slidesPerView: 4,
								spaceBetween: 30,
							}
						},
					};
					break;
				case 'fullpage-cards':
					addedOptions = {
						spaceBetween: 20,
						breakpoints: {
							768: {
								slidesPerView: 2,
								spaceBetween: 30,
							},
							1024: {
								slidesPerView: 3,
							}
						}
					};
					break;
				case 'multirow':
					addedOptions = {
						slidesPerView: 1,
						spaceBetween: 20,
						breakpoints: {
							768: {
								slidesPerView: 2,
								spaceBetween: 30,
								slidesPerColumn: 2,
								slidesPerColumnFill: 'row',
							},
							1024: {
								slidesPerView: 3,
								spaceBetween: 40,
								slidesPerColumn: 2,
								slidesPerColumnFill: 'row',
							}
						}


					};
					break;
			}

			Object.assign(options, addedOptions);
		});

		const swiper = new Swiper(slider, options);
	});
}

